var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24337 10.6149C3.32178 9.76734 3.99863 9.09961 4.84624 9.02656C8.33047 8.72627 10.7497 8.72539 14.206 9.02471C15.0577 9.09847 15.7354 9.77291 15.8108 10.6249C16.115 14.0638 16.0869 16.492 15.8001 19.9597C15.7288 20.8212 15.0465 21.5074 14.1855 21.5804C10.719 21.8743 8.30272 21.8737 4.88048 21.5818C4.01742 21.5082 3.3351 20.8184 3.2646 19.9546C2.98442 16.522 2.92206 14.0878 3.24337 10.6149Z",
    stroke: "#000F30",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20508 6.03947C8.21704 5.89961 8.22964 5.75813 8.24289 5.61488C8.3213 4.76734 8.99815 4.09961 9.84576 4.02656C13.33 3.72627 15.7492 3.72539 19.2055 4.02471C20.0572 4.09847 20.735 4.77291 20.8103 5.62494C21.1146 9.06383 21.0865 11.492 20.7996 14.9597C20.7283 15.8212 20.046 16.5074 19.185 16.5804C19.0342 16.5932 18.8854 16.6054 18.7383 16.6171",
    stroke: "#4D5975",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.d738b92442679182dfe2f11cce6f182a.svg";
export { ForwardRef as ReactComponent };